{
  "cms.benefit.field.title": "Title",
  "cms.benefit.field.logo": "Logo / image",
  "cms.benefit.field.body": "Details (shown in the accordion)",
  "cms.benefit.field.category": "Category",
  "cms.benefit.field.categoryPlaceholder": "Select a category",
  "cms.benefit.field.categoryAddNew": "+ Add new category",
  "cms.benefit.field.cities": "Cities",
  "cms.benefit.field.link": "Link (URL)",
  "cms.benefit.error.titleRequired": "Title is required (max 200 characters).",
  "cms.benefit.error.titleNotDerivable": "The title must contain at least one Latin letter or number.",
  "cms.benefit.error.logoUrl": "Logo URL must start with https:// or be a same-origin path (/media/...).",
  "cms.benefit.error.linkHttps": "Link must be an https:// URL."
}
